function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.5 12.5V14.263C5.5 14.6623 5.94507 14.9005 6.27735 14.679L9.54584 12.5H16C16.8284 12.5 17.5 11.8284 17.5 11V3C17.5 2.17157 16.8284 1.5 16 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V11C1.5 11.8284 2.17157 12.5 3 12.5H5.5ZM10 14H16C17.6569 14 19 12.6569 19 11V3C19 1.34315 17.6569 0 16 0H3C1.34315 0 0 1.34315 0 3V11C0 12.6569 1.34315 14 3 14H4V14.263C4 15.8604 5.78029 16.8131 7.1094 15.9271L10 14Z",
  fill: "#249AF3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.25 4C3.25 3.58579 3.58579 3.25 4 3.25H15C15.4142 3.25 15.75 3.58579 15.75 4C15.75 4.41421 15.4142 4.75 15 4.75H4C3.58579 4.75 3.25 4.41421 3.25 4Z",
  fill: "#249AF3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.25 7C3.25 6.58579 3.58579 6.25 4 6.25H15C15.4142 6.25 15.75 6.58579 15.75 7C15.75 7.41421 15.4142 7.75 15 7.75H4C3.58579 7.75 3.25 7.41421 3.25 7Z",
  fill: "#249AF3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.25 10C3.25 9.58579 3.58579 9.25 4 9.25H11C11.4142 9.25 11.75 9.58579 11.75 10C11.75 10.4142 11.4142 10.75 11 10.75H4C3.58579 10.75 3.25 10.4142 3.25 10Z",
  fill: "#249AF3"
});

function SvgCommentsLogIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsLogIcon);
export default __webpack_public_path__ + "static/media/CommentsLogIcon.117130b1.svg";
export { ForwardRef as ReactComponent };